export default "__VITE_ASSET__ebc95436__"